 var swiper = new Swiper(".featured-slider", {
        loop: true,
        centeredSlides: true,
        initialSlide: 1,
         breakpoints: {
            1400: {
                slidesPerView: 3.8,
                spaceBetween: 20,
            },
            
            990: {
                slidesPerView: 3.4,
                spaceBetween: 20,
            },
            0: {
                slidesPerView: 1.4,
                spaceBetween: 20,
            },
        },
        navigation: {
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom",
        },
      });